import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import config from '../config';
interface GetAccounts extends AccountQueryParams {
  axios: AxiosInstance;
}
interface AccountQueryParams {
  searchString?: string;
  page?: number;
  itemsPerPage?: number;
  status?: Array<string>;
  portalId?: number;
  country?: string;
}
async function getAccounts({ axios, searchString, page, itemsPerPage, status, portalId, country }: GetAccounts): Promise<any> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v2/account`, {
    params: {
      searchString,
      page,
      itemsPerPage,
      status: (status?.length ?? 0) > 0 ? status?.join() : undefined,
      portalId,
      country,
    },
  });
  return data;
}
export default function useAccountsQuery({ searchString, page, itemsPerPage, status, portalId, country }: AccountQueryParams) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey({
      searchString,
      page,
      itemsPerPage,
      status,
      portalId,
      country,
    }),
    queryFn: () =>
      getAccounts({
        axios,
        searchString,
        page,
        itemsPerPage,
        status,
        portalId,
        country,
      }),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey({ searchString, page, itemsPerPage, status, portalId, country }: AccountQueryParams) {
  return ['Accounts', searchString, page, itemsPerPage, status, portalId, country] as const satisfies QueryKey;
}
useAccountsQuery.getKey = getKey;
